export default "__VITE_ASSET__CeDCYNfG__"